import React from 'react';
import { GroupDropIndicator } from '@atlaskit/navigation-system/side-nav-items/drag-and-drop/group-drop-indicator';
import { useDropTargetForProjects } from '../../controllers/drop-target-for-projects.tsx';

type ProjectsDroppableGroupIndicatorProps = {
	children: React.ReactNode;
};

export const ProjectsDroppableGroupIndicator = (
	props: ProjectsDroppableGroupIndicatorProps,
): React.JSX.Element => {
	const { children } = props;
	const dropTarget = useDropTargetForProjects();
	const { ref, state } = dropTarget;
	return (
		<GroupDropIndicator isActive={state === 'is-over'} ref={ref}>
			{children}
		</GroupDropIndicator>
	);
};
